import * as React from 'react'
import { connect } from 'react-redux'

import { LOGO } from 'components/_Assets/svg/Icon/logo'
import Announcement, {
  AnnouncementType,
} from 'components/Announcement/Announcement'
import { Colour } from 'components/variables'
import { City } from '../../../data/models/funnelOrder/cities'
import { AppState } from '../../../data/state'
import AbstractTrigger from '../abstractTrigger'

interface NewCitiesTriggerProps {
  excludedCities: City[]
  showLength: number
  colour?: Colour
  children?: React.ReactNode | undefined
}

interface NewCitiesTriggerState {
  show: boolean
}

class NewCitiesTrigger extends AbstractTrigger<
  NewCitiesTriggerProps,
  NewCitiesTriggerState
> {
  public timerLength = 10000
  private prevLength: number
  constructor(props: NewCitiesTriggerProps) {
    super(props)
    this.state = {
      show: false,
    }
    this.prevLength = props.excludedCities.length
  }

  public updateShow(props: NewCitiesTriggerProps) {
    const currentLength = props.excludedCities.length
    if (currentLength !== this.prevLength) {
      if (
        currentLength > this.prevLength &&
        currentLength === this.props.showLength
      ) {
        this.setState({ show: true })
        this.startTimer(false)
      }
      this.prevLength = props.excludedCities.length
    }
  }

  public render() {
    return (
      <Announcement
        type={AnnouncementType.Info}
        show={this.state.show}
        icon={LOGO.logo}
        colour={this.props.colour}
        onClose={this.onClose}
      >
        {this.props.children}
      </Announcement>
    )
  }
}

export default connect((state: AppState) => ({
  excludedCities: state.funnelOrder.excludedCitiesIds,
}))(NewCitiesTrigger)
